import { useRouter } from 'next/router';
import parseHandleParam from 'components/route/products/utils/productSSRprops';

export function useGetDeepestHandle() {
  const router = useRouter();
  const { handle: queryHandle } = router.query;
  const defaultHandle = parseHandleParam(queryHandle);
  return defaultHandle[defaultHandle.length - 1];
}
